import { render, staticRenderFns } from "./playButton.vue?vue&type=template&id=58470200&"
import script from "./playButton.vue?vue&type=script&lang=js&"
export * from "./playButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports